import { render, staticRenderFns } from "./StoreClerkDiscount.vue?vue&type=template&id=336476a6"
import script from "./StoreClerkDiscount.vue?vue&type=script&lang=js"
export * from "./StoreClerkDiscount.vue?vue&type=script&lang=js"
import style0 from "./StoreClerkDiscount.vue?vue&type=style&index=0&id=336476a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports